/* template */
<template minapp="mpx" xlang="wxml"><div :style="[(couponBg)] | transRpxStyle" class="coupon-item-container"><div class="left-area" v-if="(displayedInfo.amount)"><span :style="[(amountColor)] | transRpxStyle" class="amount">{{ displayedInfo.amount }}</span><span :style="[(unitColor)] | transRpxStyle" class="unit">{{ displayedInfo.unit }}</span><div class="tag" v-if="(displayedInfo.product)">{{ displayedInfo.product }}</div></div><div class="right-area"><span :style="[(nameColor)] | transRpxStyle" class="name" v-if="(couponData.name)">{{ couponData.name }}</span><span :style="[(remarkColor)] | transRpxStyle" class="remark" v-if="(couponData.remark)">{{ couponData.remark }}</span></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m963e9dbc"}'>
  .coupon-item-container
    width 100%
    height 55px
    background #fff
    margin-bottom 9px
    border-radius 10px
    border 1.5px solid #000
    display flex
    align-items center
    position relative
    box-sizing border-box
    // 替换成 drop-shadow
    -webkit-mask radial-gradient(circle at 5px 50%, transparent 5px, #000 0) -5px
    mask radial-gradient(circle at 5px 50%, transparent 5px, #000 0) -5px
    &::before, &::after
      content ''
      position absolute
      top 20.9px
      width 8px
      height 8px
      border-radius 50%
      border 1.5px solid #000
    &::before
      left -5.8px
    &::after
      right -5.8px
    .left-area
      width 73px
      display flex
      flex-shrink 0
      margin-top 5px
      align-items baseline
      justify-content center
      .amount
        font-family Barlow Semi Condensed
        font-size 32px
        line-height 26px
        font-weight 400
      .unit
        font-family PingFang SC
        font-size 15px
        font-weight 600
        line-height 15px
      .tag
        background #222
        padding 2px 8px
        position absolute
        top 0
        font-family PingFangSC-Medium
        font-size 9px
        font-weight normal
        line-height 9px
        border-radius 0 0 12px 12px / 0 0 20px 20px
        clip-path polygon(0 0, 100% 0, 92% 100%, 8% 100%)
        color #fff
    .right-area
      height 48px
      padding 0 9px
      display flex
      overflow hidden
      flex-direction column
      justify-content center
      border-left 1px dashed rgba(254, 152, 53, 0.2)
      .name, .remark
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        font-family PingFang SC
        line-height 13px
      .name
        font-size 13px
        font-weight 500
      .remark
        font-size 12px
        font-weight 400
        margin-top 5px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m963e9dbc"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./coupon-item.mpx.js?isComponent&outputPath=components%2Fcoupon-item963e9dbc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./coupon-item.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcoupon-item963e9dbc%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m963e9dbc"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/coupon-item963e9dbc/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
